/* eslint-disable camelcase */
import { match } from '@nike/rcf-fp';
import { Default as _ } from '@nike/rcf-fp/src/match/match';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { currencyFormatter } from '../../../../utils/formatting';
import DiscountFormatter from '../../DiscountFormatter';

const cardEntryMethod = (cardInfo) => match(cardInfo?.EntryMethod?.toUpperCase())(
  [(method) => ['INTEGRATEDCHIPCARD'].includes(method), '<D>'],
  [(method) => ['KEYED'].includes(method), '<K>'],
  [(method) => ['RFID', 'TAPPED', 'CONTACTLESS'].includes(method), '<R>'],
  [(method) => ['SWIPED', 'MSR'].includes(method), '<S>'],
  [_, ''],
);

const GiftCard = ({
  tenderInfo,
}) => {
  const {
    // eslint-disable-next-line no-shadow
    isAdmin, locale: { storeCurrency, storeLocale }, GiftCard, RL_GiftCardNo, RL_GCBalance, RL_AuthCode, redacted,
  } = useSelector((state) => state);

  return (
    <>
      {(tenderInfo.Tender?.TypeCode === 'Sale') && (
        <>
          <article className="justify-between">
            <p>{GiftCard}</p>
            <p>
              {currencyFormatter(
                storeLocale,
                storeCurrency,
                tenderInfo?.Tender?.Amount?.Amount,
              )}
            </p>
          </article>
        </>
      )}
      {(tenderInfo.Tender?.TypeCode === 'Refund') && (
        <>
          <article className="justify-between">
            <p>{GiftCard}</p>
            <p>
              <DiscountFormatter isNegative storeLocale={storeLocale}>
                {currencyFormatter(
                  storeLocale,
                  storeCurrency,
                tenderInfo?.Tender?.Amount?.Amount,
                )}
              </DiscountFormatter>
            </p>
          </article>
        </>
      )}
      <article className="justify-between">
        <p className="pl2-sm">{RL_GiftCardNo}</p>
        <p className="pr2-sm">{isAdmin ? (tenderInfo?.Tender?.GiftCard?.CardNumber?.replace(/.(?=.{4})/g, 'X') || '') : redacted}{cardEntryMethod(tenderInfo)}</p>
      </article>
      <article className="justify-between">
        <p className="pl2-sm">{RL_GCBalance}</p>
        <p className="pr2-sm">
          {currencyFormatter(
            storeLocale,
            storeCurrency,
            tenderInfo?.Tender?.GiftCard?.CurrentBalance?.Amount,
          )}
        </p>
      </article>
      <article className="justify-between">
        <p className="pl2-sm">{RL_AuthCode}</p>
        <p className="pr2-sm">{tenderInfo?.Tender?.GiftCard?.Authorization?.AuthorizationCode}</p>
      </article>
      <br /><br />
    </>
  );
};

GiftCard.defaultProps = {
  tenderInfo: {},
};

GiftCard.propTypes = {
  tenderInfo: PropTypes.shape(),
};

export default GiftCard;
